import { RouteError } from '@/components/route-error'
import { createFileRoute } from '@tanstack/react-router'
import { RoutePending } from '@/components/route-pending'

import { TemplatesPage } from '@/features/devices/templates-page'

export const Route = createFileRoute('/_dashboard/devices/templates/$item')({
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: TemplatesItemPage,
})

function TemplatesItemPage() {
  const { item } = Route.useParams()
  return <TemplatesPage selectedId={item} />
}
